import HeaderFactory from '../../components/header/index';
import TabBar from '../../components/tab-bar/tabBar';
import Slider from '../../components/slider/slider';
import Tablist from '../../components/tablist/index';
import AccordionCard from '../../components/accordion-card/index';
import ScrollSlider from '../../components/scroll-slider/scroll-slider';
import FilterList from '../../components/filter-list/filter-list';
import Lightbox from '../../components/lightbox/lightbox';
import TableOfContent from '../../components/table-of-content/table-of-content';
import ArticleTemplate from '../../templates/article/article-template';
import SeeMore from '../../components/see-more/see-more';
import Accordion from '../../components/accordion/accordion';
import ProductList from '../../components/product-list/product-list';
import Dropdown from '../../components/dropdown/dropdown';
import DropdownLight from '../../components/dropdownlight/dropdownlight';
import Search from '../../components/search-field/search';
import {SearchBox} from '../../components/search-field/mainSearch';
import {initMenuBrs} from '../../components/menu-brs/menuBrs';
import {initToggles} from '../../components/menu-toggle/menuToggle';


export const loadComponents = function ($) {

  if ($('.js-menu-brs').length) {
    initMenuBrs();
  }

  if ($('.js-menu-left_toggle').length) {
      initToggles();
  }

  $('.js-slider').each(function (i,el) {
    new Slider($(el));
  });

  $('.js-tablist').each(function (i,el) {
    new Tablist($(el));
  });

  $('.js-accordion-card').each(function (i,el) {
    new AccordionCard($(el));
  });

  $('.js-filter-list').each(function (i,el) {
    new FilterList($(el));
  });

  new Lightbox($('.js-lightbox'));

  $('.js-see-more').each(function (i, el) {
    new SeeMore($(el));
  });

  if ($('.js-toc').length > 0 && $('.js-article').length > 0) {
    new TableOfContent($('.js-toc'));
    new ArticleTemplate();
  }

  if ($('.js-scroll-slider').length > 0) {
    new ScrollSlider($('.js-scroll-slider'));
  }

  if ($('.js-accordion_head').length > 0) {
    $('.js-accordion_head').each( (i, el) => new Accordion($(el)));
  }

  if ($('.js-product-list').length > 0) {
    $('.js-product-list').each( (i, el) => new ProductList($(el)));
  }

  if ($('.js-dropdown-old').length > 0) {
    $('.js-dropdown-old').each( (i, el) => new Dropdown($(el)));
  }

  if ($('.js-dropdown-light').length > 0) {
      $('.js-dropdown-light').each( (i, el) => new DropdownLight($(el)));
  }

  if ($('.js-search').length > 0) {
    $('.js-search').each( (i, el) => new Search($(el)));
  }

  if ($('.js-search-gsa').length) {
    new SearchBox({
      $el: $('.js-search-gsa'),
      itemIdPrefix: 'search-gsa'
    });
  }

  if ($('.js-tab-bar').length) {
    new TabBar($('.js-tab-bar'));
  };

  // bind btn print
  $('.js-btn-print').click(function() {
    window.print();
  });

  HeaderFactory.init();
};


// WEBPACK FOOTER //
// ./src/js/utils/load-components.js